import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=25140832&scoped=true&"
import script from "./GroupUsers.vue?vue&type=script&lang=ts&"
export * from "./GroupUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25140832",
  null
  
)

export default component.exports